// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getSubAccount, insertSubAccount, subAccountSelector, updateSubAccount} from './subAccountSlice';


import {Colors} from "../../../assets/Colors";

const SubAccountPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const subAccount = useSelector(
        subAccountSelector
    );


    useEffect(() => {
        dispatch(getSubAccount({
            start: start,
            count: count,
            search: '',
        }));

    }, []);

    useEffect(() => {

        if ((search !== '') && subAccount.isGetSuccess && !subAccount.isGetFetching) {
            let calc = subAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && subAccount.isGetSuccess && !subAccount.isGetFetching) {
            let calc = subAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!subAccount?.isGetFetching && subAccount.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = subAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subAccount.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getSubAccount({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (subAccount.isGetSuccess) {
                alertService.success(subAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getSubAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (subAccount.isUpdateSuccess) {
                alertService.success(subAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateSubAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetSubAccount(params) {
    //   return dispatch(getSubAccount(params));
    // }

    function handleInsertSubAccount(param) {
        setInsertFetch(true);
        const params = {
            MainAccountID: param.dropdownMainAccountValue,
            SubAccount: param.inputTwoValue,
            SubAccountID: param.inputOneValue,
        };

        dispatch(insertSubAccount(params));
    }

    function handleUpdateSubAccount(param) {
        setUpdateFetch(true);

        const params = {
            MainAccountID: param.dropdownMainAccountValue,
            SubAccount: param.inputOneValue,
            SubAccountID: currentData.SubAccountID,
            status: param.status,
        };
        dispatch(updateSubAccount(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getSubAccount(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getSubAccount(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (subAccount.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? subAccount.count : newCount,
            search: search,
        }
        dispatch(getSubAccount(params));

        setPage(1);
        setCount((newCount === "-1") ? subAccount.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="SubAccount"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master SubAccount"
                                tableData={subAccount.data}
                                colOneTitle="ID"
                                colOneData="SubAccountID"
                                colTwoTitle="Nama Sub Account"
                                colTwoData="SubAccount"
                                status="Status"

                                fetching={subAccount.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Sub Account"
                        dropdownMainAccount={true}
                        inputOneTitle="ID Sub Account"
                        inputOnePlaceholder=""
                        inputTwoTitle="Nama Sub Account"
                        inputTwoValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertSubAccount}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.SubAccountID}
                        modal={handleModal}
                        modalTitle="Ubah Sub Account"
                        dropdownMainAccount={true}
                        dropdownMainAccountValue={currentData.MainAccountID}
                        inputOneTitle="Nama Sub Account"
                        inputOneValue={currentData.SubAccount}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateSubAccount}
                    />
                }
            </div>

        )
    }

}


export default SubAccountPage;